export default {
	'IS': {}
}